module.exports = __webpack_public_path__ + "img/iPhone.336d4980.png";